import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3","key":"svg-0"}],["path",{"d":"M6 8h4l-2 8","key":"svg-1"}]]

const IconNumber72Small = createReactComponent('outline', 'number-72-small', 'Number72Small', __iconNode);

export default IconNumber72Small;